import React, { useEffect, useMemo, useState } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import {
  getNeuroGenerationProgressPercent,
  NEURO_GENERATION_POLL_INTERVAL_MS,
} from '../../../utils/neuroGeneration';

const getCurrentTimestamp = () => Math.floor(Date.now() / 1000);

type Props = {
  dateUpdate: number;
  className: string;
  labelClassName: string;
  spinStyle?: React.CSSProperties;
};

const NeuroGenerationStatus = ({
  dateUpdate,
  className,
  labelClassName,
  spinStyle,
}: Props) => {
  const [currentTimestamp, setCurrentTimestamp] = useState(getCurrentTimestamp);
  const progressPercent = useMemo(
    () => getNeuroGenerationProgressPercent(dateUpdate, currentTimestamp),
    [currentTimestamp, dateUpdate]
  );

  useEffect(() => {
    const updateCurrentTimestamp = () => {
      setCurrentTimestamp(getCurrentTimestamp());
    };

    updateCurrentTimestamp();

    const intervalId = window.setInterval(() => {
      updateCurrentTimestamp();
    }, NEURO_GENERATION_POLL_INTERVAL_MS);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [dateUpdate]);

  return (
    <span className={className}>
      <Spin
        indicator={<LoadingOutlined spin />}
        style={spinStyle}
        size="small"
      />
      <span className={labelClassName}>{progressPercent}%</span>
    </span>
  );
};

export default NeuroGenerationStatus;
